var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "#e3b964"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0S19.2,2.1,29.823,15.319c0,0,9.779-10.921,29.012-11.841l-12.4,53.2-7.638,2.5s4.28-32.791,4.932-37.787c-3.656,2.989-8.517,6.094-9.142,17.731C33.66,56.436,33.416,60.99,33.416,60.99L26.36,63.414s-.8-14.859-1.324-24.681C24.582,30.27,22.819,24.979,15.7,19.74l5.917,45.34-5.952,2.132Z",
    transform: "translate(0 0)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.78,69.8l.134-.032,4.228-9.94q-4.4,1.362-8.726,2.745l-2.789,9.017c2.594-.663,4.991-1.261,7.153-1.789",
    transform: "translate(-0.933 -1.148)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.588,72.93l1.969-8.451c-2.274.741-4.541,1.483-6.782,2.23l-1.014,7.774q3.034-.821,5.827-1.554",
    transform: "translate(-0.725 -1.238)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.145,75.769l.39-7.279q-3.156,1.073-6.262,2.152l.359,6.673q2.829-.8,5.513-1.547",
    transform: "translate(-0.523 -1.315)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.453,78.532l-.819-6.266c-1.771.626-3.522,1.254-5.267,1.884l1.344,5.77q2.414-.714,4.742-1.388",
    transform: "translate(-0.333 -1.387)",
    fill: "#e3b964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.832,81.092l-1.686-5.405c-1.461.535-2.925,1.069-4.913,1.814l2.033,4.98q2.316-.712,4.566-1.389",
    transform: "translate(-0.158 -1.453)",
    fill: "#e3b964"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoM);
export default __webpack_public_path__ + "static/media/logo_M.82c12e532bc721d6391e5fd79bc0f6f3.svg";
export { ForwardRef as ReactComponent };